import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/calendar.png'


const _withScopeId = n => (_pushScopeId("data-v-f0e4c090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container content-start" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between items-center w-full mt-8" }
const _hoisted_3 = { class: "ac-large-title mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "col-start-1 col-end-13 mt-6 text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "col-start-1 col-end-13 mt-6 text-gray-500"
}
const _hoisted_6 = {
  key: 2,
  class: "two-column-container sidebar-right col-start-1 col-end-13 mt-10"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-6" }, "Ürün Bilgileri", -1))
const _hoisted_8 = { class: "detail-card" }
const _hoisted_9 = { class: "detail-grid" }
const _hoisted_10 = { class: "detail-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Ürün Adı", -1))
const _hoisted_12 = { class: "detail-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Marka", -1))
const _hoisted_14 = { class: "detail-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Tedarikçi", -1))
const _hoisted_16 = { class: "detail-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Kategori", -1))
const _hoisted_18 = { class: "detail-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "SKU / Stok Kodu", -1))
const _hoisted_20 = { class: "detail-field mt-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Açıklama", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[3.6rem] mb-6" }, "Adet", -1))
const _hoisted_23 = { class: "detail-card" }
const _hoisted_24 = { class: "detail-grid" }
const _hoisted_25 = { class: "detail-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Toplam Miktar", -1))
const _hoisted_27 = {
  key: 0,
  class: "font-semibold text-red-600"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "detail-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Miktar Birimi", -1))
const _hoisted_31 = { class: "detail-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Yenileme Eşiği", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-6" }, null, -1))
const _hoisted_34 = { class: "detail-grid" }
const _hoisted_35 = { class: "detail-field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "İlk Alış Birim Fiyatı", -1))
const _hoisted_37 = { class: "detail-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Güncel Birim Değer", -1))
const _hoisted_39 = { class: "detail-field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Toplam Güncel Değer", -1))
const _hoisted_41 = { class: "font-semibold" }
const _hoisted_42 = { class: "detail-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Toplam Alış Maliyeti", -1))
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "flex items-center justify-between !mt-[3.6rem] mb-6" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-0" }, "Partiler (Satın Alma Geçmişi)", -1))
const _hoisted_48 = {
  key: 0,
  class: "alt-table w-full"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Alış Tarihi"),
    /*#__PURE__*/_createElementVNode("th", null, "Durum"),
    /*#__PURE__*/_createElementVNode("th", null, "Kalan / Alınan"),
    /*#__PURE__*/_createElementVNode("th", null, "Birim Fiyat"),
    /*#__PURE__*/_createElementVNode("th", null, "Kalan Tutar"),
    /*#__PURE__*/_createElementVNode("th", null, "Not")
  ])
], -1))
const _hoisted_50 = {
  key: 1,
  class: "text-2xl italic text-gray-400"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[3.6rem] mb-6" }, "Stok Hareketleri", -1))
const _hoisted_52 = {
  key: 2,
  class: "alt-table w-full"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Tarih"),
    /*#__PURE__*/_createElementVNode("th", null, "İşlem"),
    /*#__PURE__*/_createElementVNode("th", null, "Açıklama"),
    /*#__PURE__*/_createElementVNode("th", null, "Hedef Şantiye"),
    /*#__PURE__*/_createElementVNode("th", null, "Kullanıcı")
  ])
], -1))
const _hoisted_54 = {
  key: 3,
  class: "text-2xl italic text-gray-400"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[3.6rem] mb-6" }, "Yorumlar", -1))
const _hoisted_56 = {
  key: 4,
  class: "mb-8"
}
const _hoisted_57 = {
  key: 5,
  class: "text-2xl italic text-gray-400 mb-6"
}
const _hoisted_58 = { class: "image-area mb-8" }
const _hoisted_59 = ["src"]
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  key: 0,
  class: "text-center text-gray-500 py-8"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-6" }, "İşlemler", -1))
const _hoisted_63 = { class: "flex flex-col" }
const _hoisted_64 = { class: "info-box mt-[3.6rem]" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Konum Bilgileri", -1))
const _hoisted_66 = { class: "detail-field" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Depo", -1))
const _hoisted_68 = { class: "detail-field" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Alt Konum", -1))
const _hoisted_70 = { class: "detail-field" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Alt Konum Detayı", -1))
const _hoisted_72 = { class: "info-box mt-[3.6rem]" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Garanti Bilgileri", -1))
const _hoisted_74 = { class: "detail-field" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Garanti Süresi (ay)", -1))
const _hoisted_76 = { class: "detail-field" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Garanti Başlangıcı", -1))
const _hoisted_78 = { class: "detail-field" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Garanti Bitişi", -1))
const _hoisted_80 = { class: "info-box mt-[3.6rem]" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Kayıt Bilgileri", -1))
const _hoisted_82 = {
  key: 0,
  class: "detail-field"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Ekleyen", -1))
const _hoisted_84 = { class: "flex items-center gap-2" }
const _hoisted_85 = ["src"]
const _hoisted_86 = { class: "detail-field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Oluşturulma", -1))
const _hoisted_88 = { class: "flex items-center gap-2" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 filter-main",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_90 = {
  key: 1,
  class: "detail-field"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Güncelleyen", -1))
const _hoisted_92 = { class: "flex items-center gap-2" }
const _hoisted_93 = ["src"]
const _hoisted_94 = { class: "detail-field" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail-label" }, "Son Güncelleme", -1))
const _hoisted_96 = { class: "flex items-center gap-2" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 filter-main",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_98 = { class: "ac-main-form !border-none" }
const _hoisted_99 = { class: "mb-4 text-xl" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-lg text-gray-500" }, "En eski partiden başlayarak (FIFO) düşülecektir.", -1))
const _hoisted_101 = { class: "ac-form-control w-full" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "removeAmount" }, "Çıkarılacak miktar", -1))
const _hoisted_103 = ["max"]
const _hoisted_104 = { class: "ac-form-control w-full" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "removeWorksite" }, "Gönderilen Şantiye", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Şantiye Belirtilmemiş", -1))
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "flex items-center justify-center gap-6 w-full" }

import { ref, computed, onMounted, onBeforeMount, onBeforeUnmount } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import { v4 as uuidv4 } from "uuid"
import firebase from "@/firebase"
import "firebase/storage"
import { updateData, useGetDocs } from "@/mixins/modularFirebaseOperations"
import { formatUser, formatDate, modalClosed } from "@/mixins/visualFormatters"
import {
    getQuantityLabel,
    formatMoney,
    conditionLabels,
    quantityTypeOptions,
    createBatch,
    sortBatchesFIFO,
    purchaseCostByCurrency,
    getWorksiteLabel,
    requiresWholeUnits,
    addBatchTransaction,
    removeStockTransaction,
} from "@/composables/inventoryHelpers"
import resetBackground from "@/mixins/resetBackground"
import removeBackground from "@/mixins/removeBackground"
import AcMediumModal from "@/components/reusable/teleports/acMediumModal.vue"
import AccaDnDUpload from "@/components/reusable/accaDnDUpload.vue"
import InventoryBatchForm from "@/components/reusable/form-widgets/inventoryBatchForm.vue"
import EditableField from "@/components/reusable/editableField.vue"
import EditableTextarea from "@/components/reusable/editableTextarea.vue"
import CommentField from "@/components/reusable/commentField.vue"
import CommentListDisplayer from "@/components/reusable/commentListDisplayer.vue"
import type { AcInventoryItem, AcInventoryUpdate, AcProductBrand, AcSupplier, AcProductCategory, AcInventoryLocation, AcInventoryWorksite } from "@/types/inventory"

// Translated labels for the stock-movement update types
const COLLECTION = "inventory/items/list"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryDetail',
  setup(__props) {


const updateTypeLabels: Record<AcInventoryUpdate["updateType"], string> = {
    ADD: "Ekleme",
    REMOVE: "Çıkartma",
    UPDATE: "Güncelleme",
}

const route = useRoute()
const router = useRouter()
const store = useStore()
const itemId = route.params.id as string

const userProfile = computed(() => store.getters["user/userProfile"])
const formattedUser = computed(() => formatUser(userProfile.value))

const item = ref<(AcInventoryItem & { id: string }) | null>(null)
const isLoading = ref(true)
const isUploadingImage = ref(false)

let unsubscribe: (() => void) | null = null

// Meta lists for the editable dropdowns
const { docs: brands } = useGetDocs<AcProductBrand>("inventory/brands/list")
const { docs: suppliers } = useGetDocs<AcSupplier>("inventory/suppliers/list")
const { docs: categories } = useGetDocs<AcProductCategory>("inventory/categories/list")
const { docs: locations } = useGetDocs<AcInventoryLocation>("inventory/locations/list")
const { docs: worksites } = useGetDocs<AcInventoryWorksite>("inventory/worksites/list")

const brandOptions = computed(() => brands.value.map((b) => ({ label: b.name, value: b })))
const supplierOptions = computed(() => suppliers.value.map((s) => ({ label: s.name, value: s })))
const categoryOptions = computed(() => categories.value.map((c) => ({ label: c.name, value: c })))
const locationOptions = computed(() => locations.value.map((l) => ({ label: l.name, value: l })))
// Only active worksites are offered as removal destinations.
const activeWorksites = computed(() => worksites.value.filter((w) => w.isActive))
const quantityTypeSelectOptions = quantityTypeOptions.map((o) => ({ label: o.label, value: o.value }))

// ---- Derived values ----
const sortedBatches = computed(() => sortBatchesFIFO(item.value?.batches ?? []))

const totalValue = computed(() => {
    if (!item.value?.quantity || !item.value?.currentValue) return null
    return item.value.quantity * item.value.currentValue
})

const purchaseCosts = computed(() => purchaseCostByCurrency(item.value?.batches))

const toDisplayDate = (value: any): string => {
    if (!value) return "-"
    const date = value?.toDate ? value.toDate() : new Date(value)
    return formatDate(date)
}

const supplierName = (supplier: AcInventoryItem["supplier"]): string => {
    if (!supplier) return "-"
    return typeof supplier === "string" ? supplier : supplier.name || "-"
}

// Stock changes are persisted via Firestore transactions (see inventoryHelpers); the
// live onSnapshot listener below refreshes `item` once the write lands.

// ---- Add stock (new batch) ----
const isAddingBatch = ref(false)
const handleBatchSubmitted = async (payload: any) => {
    if (!item.value) return
    const batch = createBatch({ ...payload, addedBy: formattedUser.value })
    try {
        await addBatchTransaction(itemId, batch, formattedUser.value, item.value.quantityType)
    } catch (error: any) {
        alert(error?.message ?? `Bir hata oluştu: ${error}`)
        return
    }
    isAddingBatch.value = false
    modalClosed()
}

// ---- Remove stock (FIFO) ----
const isRemoving = ref(false)
const removeAmount = ref<number | null>(null)
const removeWorksiteId = ref<string>("")
const confirmRemove = async () => {
    if (!item.value) return
    const amount = Number(removeAmount.value)
    const label = getQuantityLabel(item.value.quantityType)
    if (isNaN(amount) || amount <= 0) {
        alert("Lütfen geçerli bir miktar giriniz.")
        return
    }
    if (requiresWholeUnits(item.value.quantityType) && !Number.isInteger(amount)) {
        alert("Bu ürün adet ile takip edilir; lütfen tam sayı giriniz.")
        return
    }
    if (amount > item.value.quantity) {
        alert(`Mevcut stoktan (${item.value.quantity} ${label}) daha fazlasını çıkaramazsınız.`)
        return
    }
    const worksite = activeWorksites.value.find((w) => w.id === removeWorksiteId.value) ?? null
    try {
        // InsufficientStockError carries a localized message; any other error falls through too.
        await removeStockTransaction(itemId, amount, formattedUser.value, item.value.quantityType, worksite)
    } catch (error: any) {
        alert(error?.message ?? `Bir hata oluştu: ${error}`)
        return
    }
    isRemoving.value = false
    removeAmount.value = null
    removeWorksiteId.value = ""
    modalClosed()
}

// ---- Inline editable item-level fields ----
const updateSingleItemField = async (field: string, value: any) => {
    await updateData(COLLECTION, itemId, {
        [field]: value,
        updatedAt: new Date(),
        updatedBy: formattedUser.value,
    })
}

// ---- Comments ----
const addCommentToItem = async (comment: string) => {
    const commentObj = {
        comment,
        date: new Date(),
        user: formattedUser.value,
    }
    await updateData(COLLECTION, itemId, {
        comments: firebase.firestore.FieldValue.arrayUnion(commentObj),
        updatedAt: new Date(),
        updatedBy: formattedUser.value,
    })
}

// ---- Delete (archive) ----
const handleDelete = async () => {
    const confirmation = confirm("Bu ürünü arşivlemek istediğinize emin misiniz? Ürün stok listesinde görünmeyecektir.")
    if (!confirmation) return
    await updateData(COLLECTION, itemId, {
        status: "ARCHIVED",
        updatedAt: new Date(),
        updatedBy: formattedUser.value,
    })
    router.push("/inventory/items")
}

// ---- Image upload ----
const uploadInventoryImage = async (file: File): Promise<string | undefined> => {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const ext = file.name.split(".").pop()
    const fileName = `${uuidv4()}.${ext}`
    const fileRef = firebase.storage().ref().child(`inventory/${year}/${month}/${fileName}`)
    try {
        await fileRef.put(file)
        return await fileRef.getDownloadURL()
    } catch (error) {
        console.error(error)
        alert(`Görsel yüklenirken bir hata oluştu: ${error}`)
        return undefined
    }
}

const handleImageSelected = async (files: File[]) => {
    if (!files || !files.length) return
    isUploadingImage.value = true
    const url = await uploadInventoryImage(files[0])
    if (url) await updateSingleItemField("productImage", url)
    isUploadingImage.value = false
}

onMounted(() => {
    unsubscribe = firebase.firestore().doc(`${COLLECTION}/${itemId}`).onSnapshot((doc) => {
        item.value = doc.exists ? ({ id: doc.id, ...doc.data() } as AcInventoryItem & { id: string }) : null
        isLoading.value = false
    }, (error) => {
        console.error(error)
        isLoading.value = false
    })
})

onBeforeMount(() => {
    removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
    if (unsubscribe) unsubscribe()
    resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(item.value?.productName || "Ürün Detayı"), 1),
      _createElementVNode("button", {
        type: "button",
        class: "ac-add-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/inventory/items')))
      }, " ← Stok Listesine Dön ")
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Yükleniyor..."))
      : (!item.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Ürün bulunamadı."))
        : (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createElementVNode("main", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(EditableField, {
                      value: item.value.productName,
                      type: "text",
                      onUpdate: _cache[1] || (_cache[1] = ($event: any) => (updateSingleItemField('productName', $event)))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(EditableField, {
                      value: item.value.productBrand,
                      type: "select",
                      options: brandOptions.value,
                      display: item.value.productBrand?.name,
                      placeholder: "Marka seçiniz",
                      onUpdate: _cache[2] || (_cache[2] = ($event: any) => (updateSingleItemField('productBrand', $event)))
                    }, null, 8, ["value", "options", "display"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(EditableField, {
                      value: item.value.supplier,
                      type: "select",
                      options: supplierOptions.value,
                      display: supplierName(item.value.supplier),
                      placeholder: "Tedarikçi seçiniz",
                      onUpdate: _cache[3] || (_cache[3] = ($event: any) => (updateSingleItemField('supplier', $event)))
                    }, null, 8, ["value", "options", "display"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(EditableField, {
                      value: item.value.productCategory,
                      type: "select",
                      options: categoryOptions.value,
                      display: item.value.productCategory?.name,
                      placeholder: "Kategori seçiniz",
                      onUpdate: _cache[4] || (_cache[4] = ($event: any) => (updateSingleItemField('productCategory', $event)))
                    }, null, 8, ["value", "options", "display"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(EditableField, {
                      value: item.value.productSKU,
                      type: "text",
                      placeholder: "SKU giriniz",
                      onUpdate: _cache[5] || (_cache[5] = ($event: any) => (updateSingleItemField('productSKU', $event)))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(EditableTextarea, {
                    text: item.value.productDescription,
                    placeholder: "buraya tıklayarak bir ürün açıklaması girebilirsiniz",
                    onEditCompleted: _cache[6] || (_cache[6] = ($event: any) => (updateSingleItemField('productDescription', $event)))
                  }, null, 8, ["text"])
                ])
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    (item.value.quantity === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Stokta yok"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.value.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.value.quantityType)), 1))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(EditableField, {
                      value: item.value.quantityType,
                      type: "select",
                      options: _unref(quantityTypeSelectOptions),
                      onUpdate: _cache[7] || (_cache[7] = ($event: any) => (updateSingleItemField('quantityType', $event)))
                    }, null, 8, ["value", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(EditableField, {
                      value: item.value.renewThreshold ?? 0,
                      type: "number",
                      onUpdate: _cache[8] || (_cache[8] = ($event: any) => (updateSingleItemField('renewThreshold', $event)))
                    }, null, 8, ["value"])
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", null, _toDisplayString(_unref(formatMoney)(item.value.originalPrice, item.value.purchaseCurrency)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(EditableField, {
                      value: item.value.currentValue ?? 0,
                      type: "number",
                      label: item.value.purchaseCurrency,
                      onUpdate: _cache[9] || (_cache[9] = ($event: any) => (updateSingleItemField('currentValue', $event)))
                    }, null, 8, ["value", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatMoney)(totalValue.value, item.value.purchaseCurrency)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    (purchaseCosts.value.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchaseCosts.value, (cost, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: cost.currency
                            }, _toDisplayString(i > 0 ? " + " : "") + _toDisplayString(_unref(formatMoney)(cost.total, cost.currency)), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_45, "-"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("button", {
                  class: "ac-add-button text-2xl",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (isAddingBatch.value = true))
                }, "Parti Ekle")
              ]),
              (sortedBatches.value.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedBatches.value, (batch) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: batch.id,
                          class: _normalizeClass({ 'opacity-50': batch.quantity === 0 })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(toDisplayDate(batch.purchaseDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(_unref(conditionLabels)[batch.condition]), 1),
                          _createElementVNode("td", null, _toDisplayString(batch.quantity) + " / " + _toDisplayString(batch.initialQuantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.value.quantityType)), 1),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatMoney)(batch.unitPrice, batch.purchaseCurrency)), 1),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatMoney)(batch.quantity * batch.unitPrice, batch.purchaseCurrency)), 1),
                          _createElementVNode("td", null, _toDisplayString(batch.note || "-"), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_50, "Henüz parti kaydı bulunmuyor.")),
              _hoisted_51,
              (item.value.updates && item.value.updates.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...item.value.updates].reverse(), (update, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(toDisplayDate(update.updateDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(updateTypeLabels[update.updateType] || update.updateType), 1),
                          _createElementVNode("td", null, _toDisplayString(update.updateDescription), 1),
                          _createElementVNode("td", null, _toDisplayString(update.updateType === "REMOVE" ? _unref(getWorksiteLabel)(update.worksite) : "-"), 1),
                          _createElementVNode("td", null, _toDisplayString(update.updateBy?.userName || "-"), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_54, "Henüz stok hareketi bulunmuyor.")),
              _hoisted_55,
              (item.value.comments && item.value.comments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createVNode(CommentListDisplayer, {
                      comments: item.value.comments
                    }, null, 8, ["comments"])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_57, "Bu ürün için henüz yorum eklenmemiş.")),
              _createVNode(CommentField, {
                class: "w-3/4 pb-12",
                placeholder: "Yorumunuzu buraya yazın veya iptal etmek için 'esc' tuşuna basın.",
                onCommentSubmitted: _cache[11] || (_cache[11] = ($event: any) => (addCommentToItem($event)))
              })
            ]),
            _createElementVNode("aside", null, [
              _createElementVNode("div", _hoisted_58, [
                (item.value.productImage)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.value.productImage,
                      alt: "Ürün Görseli",
                      class: "product-image"
                    }, null, 8, _hoisted_59))
                  : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      (isUploadingImage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Görsel yükleniyor..."))
                        : (_openBlock(), _createBlock(AccaDnDUpload, {
                            key: 1,
                            "single-file": true,
                            allow: ['image/*'],
                            onFilesChanged: handleImageSelected
                          }))
                    ]))
              ]),
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("button", {
                  class: "ac-primary-button w-full text-2xl mb-4",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (isAddingBatch.value = true))
                }, "Stok Ekle (Parti)"),
                _createElementVNode("button", {
                  class: "ac-secondary-button w-full text-2xl mb-4",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (isRemoving.value = true))
                }, "Stok Çıkar"),
                _createElementVNode("button", {
                  class: "ac-secondary-button button-negative w-full text-2xl mb-4",
                  onClick: handleDelete
                }, "Sil (Arşivle)")
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode(EditableField, {
                    value: item.value.location,
                    type: "select",
                    options: locationOptions.value,
                    display: item.value.location?.name,
                    placeholder: "Depo seçiniz",
                    onUpdate: _cache[14] || (_cache[14] = ($event: any) => (updateSingleItemField('location', $event)))
                  }, null, 8, ["value", "options", "display"])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createVNode(EditableField, {
                    value: item.value.subLocation,
                    type: "text",
                    placeholder: "Alt konum giriniz",
                    onUpdate: _cache[15] || (_cache[15] = ($event: any) => (updateSingleItemField('subLocation', $event)))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(EditableField, {
                    value: item.value.subLocationDetail,
                    type: "text",
                    placeholder: "Detay giriniz",
                    onUpdate: _cache[16] || (_cache[16] = ($event: any) => (updateSingleItemField('subLocationDetail', $event)))
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createVNode(EditableField, {
                    value: item.value.warrantyPeriod ?? 0,
                    type: "number",
                    onUpdate: _cache[17] || (_cache[17] = ($event: any) => (updateSingleItemField('warrantyPeriod', $event)))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(EditableField, {
                    value: item.value.warrantyStart,
                    type: "date",
                    placeholder: "Tarih seçiniz",
                    onUpdate: _cache[18] || (_cache[18] = ($event: any) => (updateSingleItemField('warrantyStart', $event)))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createVNode(EditableField, {
                    value: item.value.warrantyEnd,
                    type: "date",
                    placeholder: "Tarih seçiniz",
                    onUpdate: _cache[19] || (_cache[19] = ($event: any) => (updateSingleItemField('warrantyEnd', $event)))
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                (item.value.addedBy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("span", _hoisted_84, [
                        (item.value.addedBy.profileImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.value.addedBy.profileImage,
                              referrerpolicy: "no-referrer",
                              alt: "",
                              class: "rounded-image-mini rounded-full"
                            }, null, 8, _hoisted_85))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.value.addedBy.userName || "-"), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createElementVNode("span", _hoisted_88, [
                    _hoisted_89,
                    _createTextVNode(" " + _toDisplayString(toDisplayDate(item.value.createdAt)), 1)
                  ])
                ]),
                (item.value.updatedBy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("span", _hoisted_92, [
                        (item.value.updatedBy.profileImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.value.updatedBy.profileImage,
                              referrerpolicy: "no-referrer",
                              alt: "",
                              class: "rounded-image-mini rounded-full"
                            }, null, 8, _hoisted_93))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.value.updatedBy.userName || "-"), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createElementVNode("span", _hoisted_96, [
                    _hoisted_97,
                    _createTextVNode(" " + _toDisplayString(toDisplayDate(item.value.updatedAt)), 1)
                  ])
                ])
              ])
            ])
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingBatch.value && item.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                width: "44vw",
                height: "fit-content",
                title: "Stok Ekle (Yeni Parti)",
                onModalClosed: _cache[21] || (_cache[21] = ($event: any) => {isAddingBatch.value = false; _unref(modalClosed)()})
              }, {
                default: _withCtx(() => [
                  _createVNode(InventoryBatchForm, {
                    "quantity-label": _unref(getQuantityLabel)(item.value.quantityType),
                    "default-currency": item.value.purchaseCurrency,
                    "integer-only": _unref(requiresWholeUnits)(item.value.quantityType),
                    onBatchSubmitted: handleBatchSubmitted,
                    onCancel: _cache[20] || (_cache[20] = ($event: any) => {isAddingBatch.value = false; _unref(modalClosed)()})
                  }, null, 8, ["quantity-label", "default-currency", "integer-only"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isRemoving.value && item.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44",
                width: "34vw",
                height: "fit-content",
                title: "Stok Çıkar",
                onModalClosed: _cache[25] || (_cache[25] = ($event: any) => {isRemoving.value = false; removeAmount.value = null; removeWorksiteId.value = ''; _unref(modalClosed)()})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("p", _hoisted_99, [
                      _createElementVNode("strong", null, _toDisplayString(item.value.productName), 1),
                      _createTextVNode(" — mevcut miktar: " + _toDisplayString(item.value.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.value.quantityType)), 1)
                    ]),
                    _hoisted_100,
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _withDirectives(_createElementVNode("input", {
                        id: "removeAmount",
                        type: "number",
                        min: "1",
                        max: item.value.quantity,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((removeAmount).value = $event)),
                        onKeyup: _withKeys(confirmRemove, ["enter"])
                      }, null, 40, _hoisted_103), [
                        [_vModelText, removeAmount.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _withDirectives(_createElementVNode("select", {
                        id: "removeWorksite",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((removeWorksiteId).value = $event))
                      }, [
                        _hoisted_106,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeWorksites.value, (worksite) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: worksite.id,
                            value: worksite.id
                          }, _toDisplayString(worksite.name), 9, _hoisted_107))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, removeWorksiteId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ac-primary-button text-2xl mt-4",
                        onClick: confirmRemove
                      }, "Kaydet"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ac-secondary-button text-2xl mt-4",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => {isRemoving.value = false; removeAmount.value = null; removeWorksiteId.value = ''; _unref(modalClosed)()})
                      }, "İptal")
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})